
export default {
  name: 'SelectBrand',
  props: {
    id: String,
    name: String,
    value: Number,
    placeholder: { type: String }
  },
  computed: {
    brands () {
      return this.$store.getters['layout/getBrands']
    }
  },
  methods: {
    handleInput (event) {
      this.$emit('input', event.target.value === '' ? null : parseInt(event.target.value))
    },
  },
}
